import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Helmet } from "react-helmet-async";
import { GraduationCap, ShoppingBag, Rocket, Video, TrendingUp, BookOpen } from "lucide-react";

const subServices = ["TikTok Shop Setup", "Start a Brand", "E-commerce Mastery", "Content Strategy"];

const features = [
  {
    icon: ShoppingBag,
    title: "TikTok Shop Setup",
    description: "Learn how to set up and optimize your TikTok Shop from scratch, including product listings and fulfillment.",
  },
  {
    icon: Rocket,
    title: "How to Start a Brand",
    description: "Complete guide to building a brand from idea to launch - naming, positioning, and market entry.",
  },
  {
    icon: Video,
    title: "Content Creation Basics",
    description: "Master the fundamentals of creating engaging content that converts viewers into customers.",
  },
  {
    icon: TrendingUp,
    title: "E-commerce Fundamentals",
    description: "Learn the essentials of running a successful online store, from setup to scaling.",
  },
  {
    icon: BookOpen,
    title: "Social Media Marketing",
    description: "Strategies for growing your presence across TikTok, Instagram, and other platforms.",
  },
  {
    icon: GraduationCap,
    title: "Business Automation",
    description: "Discover tools and techniques to automate your business and free up your time.",
  },
];

const benefits = [
  {
    title: "Learn at Your Pace",
    description: "Self-paced courses that fit around your schedule. Learn whenever works best for you.",
  },
  {
    title: "Practical Skills",
    description: "Real-world, actionable knowledge you can apply immediately to your business.",
  },
  {
    title: "Expert Guidance",
    description: "Courses created by industry professionals with 15+ years of experience.",
  },
  {
    title: "Lifetime Access",
    description: "Get lifetime access to course materials and all future updates.",
  },
];

const process = [
  {
    title: "Choose",
    description: "Browse our courses and pick the skills you want to learn.",
  },
  {
    title: "Learn",
    description: "Work through video lessons, guides, and practical exercises.",
  },
  {
    title: "Apply",
    description: "Put your new knowledge into practice with real projects.",
  },
  {
    title: "Grow",
    description: "Watch your business transform with your new skills.",
  },
];

export default function LearnSkills() {
  return (
    <>
      <Helmet>
        <title>Digital Skills Training | Learn Web, Social & Marketing | Barton</title>
        <meta name="description" content="Learn valuable digital skills from industry experts. Training courses in web design, social media, marketing, and AI tools for business owners." />
        <meta property="og:title" content="Digital Skills Training | Barton" />
        <meta property="og:description" content="Learn valuable digital skills. Training courses in web design, social media, marketing, and AI tools." />
        <meta property="og:url" content="https://barton.uk/services/learn-skills" />
        <meta property="og:image" content="https://barton.uk/og-image.png" />
        <meta name="twitter:title" content="Digital Skills Training | Barton" />
        <meta name="twitter:description" content="Training courses in web design, social media, marketing, and AI tools." />
        <meta name="twitter:image" content="https://barton.uk/og-image.png" />
      </Helmet>
      <ServicePageTemplate
        title="Learn Skills"
        subtitle="Master the Digital Game"
        description="Online courses designed to teach you everything from setting up a TikTok Shop to building a successful brand. Learn the skills you need to grow your business."
        image="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80"
        icon={GraduationCap}
        features={features}
        benefits={benefits}
        process={process}
        subServices={subServices}
        ctaText="Get In Touch"
        accentColor="blue"
      />
    </>
  );
}
